import Slide from '@/mixins/Slide'
import HorizontalScroll from '@/components/HorizontalScroll'
import IconArrowCircle from '@/components/IconArrowCircle'

export default
{
    mixins: [
        Slide
    ],

    components: {
        HorizontalScroll,
        IconArrowCircle
    },

    data()
    {
        return {
            linesOpen: {},
            current: 'past'
        }
    },

    watch:
    {
        current(current)
        {
            this.$store.color = current === 'past' ? 'blue' : 'green'
        }
    },

    computed:
    {
        content()
        {
            return this.$store.slide13
        }
    },

    methods:
    {
        toggleLinesOpen(tag)
        {
            this.$set(this.linesOpen, tag, !this.linesOpen[tag])
        },

        previous()
        {
            if(this.current === 'future')
            {
                this.current = 'past'
                return true
            }

            return false
        },

        next()
        {
            if(this.current === 'past')
            {
                this.current = 'future'
                return true
            }

            return false
        }
    }
}
